import { create } from 'zustand'

import type { UseInventoryProps } from './types'
import { exportPdf } from './provider'

export const useInventory = create<UseInventoryProps>(() => ({
  exportPdf
}))
